<template>
	<div class="full page_container">
		<el-tabs class="tabs flex" v-model="activeName" type="border-card">
			<el-tab-pane label="商品" v-if="findChildren(20)!==-1" name="goods" style="height: 100%;">
				<goods-index />
			</el-tab-pane>
			<el-tab-pane label="商品税收分类" v-if="findChildren(142)!==-1" name="goodsrevenueinfo" style="height: 100%;">
				<goodsrevenueinfo-index />
			</el-tab-pane>
			<el-tab-pane label="线上商品" v-if="findChildren(42)!==-1" name="goodsonline" style="height: 100%;">
				<goodsonline-index />
			</el-tab-pane>
			<el-tab-pane label="组合商品" v-if="findChildren(61)!==-1" name="goodsgroup" style="height: 100%;">
				<goodsgroup-index />
			</el-tab-pane>
		</el-tabs>


	</div>
</template>
<style scoped>
	.departmen_container {
		padding: 10px;
		box-sizing: border-box;
		flex-direction: column;
	}

	.tabs {
		flex-direction: column;
		position: relative;
		width: 100%;
		height: 100%;
	}
</style>
<script>
	import goodsIndex from './goods/index.vue'
	import goodsrevenueinfoIndex from './goodsrevenueinfo/index.vue'
	import goodsonlineIndex from './goodsonline/index.vue'
	import goodsgroupIndex from './goodsgroup/index.vue'
	export default {
		props: {

		},
		data() {
			return {
				activeName: '',
				activeIndex: '',
				departmentChildren: [],

			}
		},
		watch: {

		},
		created() {
			this.departmentChildren = this.$router.currentRoute.meta.children
			if (this.departmentChildren.length != 0) {
				// this.activeName = this.departmentChildren[0].controller
				this.activeName = 'goods'
			}
			//console.log(this.departmentChildren)
		},
		mounted() {

		},
		computed: {

		},

		methods: {
			findChildren(id) {
				return this.departmentChildren.findIndex((item) => {
					return item.id == id
				})
			},
		},
		components: {
			goodsIndex,
			goodsrevenueinfoIndex,
			goodsonlineIndex,
			goodsgroupIndex
		}
	}
</script>